import { useWatch } from "react-hook-form";
import { TextField, Checkbox } from "../../../../shared";
import { Grid } from "@mui/joy";

export function InsuranceDetails() {
    const noInsurance = useWatch({ name: "noInsurance" }) ?? false;
    const hasInsurance = !noInsurance;

    return (
        <Grid container spacing={2} mt={0}>
            <Grid xs={6}>
                <TextField
                    name={"insuranceProvider"}
                    label={"Insurance Provider"}
                    placeholder={"ABC Insurance"}
                    helperText={"Name of the insurance provider"}
                />
            </Grid>
            <Grid xs={6}>
                <TextField
                    name={"policyNumber"}
                    label={"Policy Number"}
                    placeholder={"INS-123456"}
                    helperText={"Insurance policy number"}
                />
            </Grid>
            <Grid xs={6}>
                <TextField
                    name={"claimNumber"}
                    label={"Claim Number"}
                    placeholder={"CL-7890"}
                    helperText={"Insurance claim number (if applicable)"}
                />
            </Grid>
            <Grid xs={6}>
                <TextField
                    name={"adjusterContact"}
                    label={"Adjuster Contact"}
                    placeholder={"(123) 456-7890"}
                    helperText={"Adjuster's phone number"}
                />
            </Grid>
            <Grid xs={6}>
                <TextField
                    name={"adjusterEmail"}
                    label={"Adjuster Email"}
                    placeholder={"jane.doe@test.com"}
                    helperText={"Adjuster's email address"}
                />
            </Grid>
            <Grid xs={12} mt={2}>
                <Checkbox
                    name="noInsurance"
                    label="This project does not have insurance details"
                    size="sm"
                    defaultChecked={false}
                    helperText={
                        hasInsurance
                            ? "Check this box if this project does not involve insurance claims or coverage"
                            : "Insurance details are not required for this project. You can add them later if needed."
                    }
                />
            </Grid>
        </Grid>
    );
}
